var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"body"},[_c('custom-header',{attrs:{"active":"global","subActive":_vm.current}}),_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"history-content",domProps:{"innerHTML":_vm._s(_vm.desc)}})]),_c('custom-footer',{attrs:{"friendLink":_vm.friendLink}}),_c('scroll-top',{on:{"scrollTop":_vm.scrollTop}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }